import { createStore } from 'satcheljs';
import { map } from 'mobx';
export default createStore('upNextViewState', {
    calendarItems: map(),
    isAgendaOpen: false,
    isExpansionOpen: false,
    weatherClickThrough: '',
    weatherDailyConditions: [],
})();
//# sourceMappingURL=store.js.map